module.exports = {
    routesData: () => {
        return[
            {
                "NUEVO HB20 AZUL SAFIRO": 'spins/HB20ADVANCERIN/AzulSafiro',
                "NUEVO HB20 ROJO DRAGON": 'spins/HB20ADVANCERIN/RojoDragon',
                "NUEVO HB20 BLANCO ATLAS": 'spins/HB20ADVANCERIN/BlancoAtlas',
                "NUEVO HB20 PLATA DIAMANTE": 'spins/HB20ADVANCERIN/PlataDiamante',
                "NUEVO HB20 NEGRO SOLIDO": 'spins/HB20ADVANCERIN/NegroSolido',
                "NUEVO HB20 GRIS METALIZADO": 'spins/HB20ADVANCERIN/GrisMetalizado',

                "NUEVO HB20S AZUL SAFIRO": 'spins/HB20SADVANCERIN/AzulSafiro',
                "NUEVO HB20S ROJO DRAGON": 'spins/HB20SADVANCERIN/RojoDragon',
                "NUEVO HB20S BLANCO ATLAS": 'spins/HB20SADVANCERIN/BlancoAtlas',
                "NUEVO HB20S PLATA DIAMANTE": 'spins/HB20SADVANCERIN/PlataDiamante',
                "NUEVO HB20S NEGRO SOLIDO": 'spins/HB20SADVANCERIN/NegroSolido',
                "NUEVO HB20S GRIS METALIZADO": 'spins/HB20SADVANCERIN/GrisMetalizado',

                "HB20X ADVANCE ROJO DRAGON": 'spins/HB20XADVANCE/RojoDragon',
                "HB20X ADVANCE BLANCO ATLAS": 'spins/HB20XADVANCE/BlancoAtlas',
                "HB20X ADVANCE PLATA DIAMANTE": 'spins/HB20XADVANCE/PlataDiamante',
                "HB20X ADVANCE GRIS METALIZADO": 'spins/HB20XADVANCE/GrisMetalizado',

                "TUCSON NX4 PREMIUM BLANCO POLAR": 'spins/TUCSON/blancopolar',
                "TUCSON NX4 PREMIUM BRONCE SIENA": 'spins/TUCSON/broncesiena',
                "TUCSON NX4 PREMIUM GRIS ASTRAL": 'spins/TUCSON/grisastral',
                "TUCSON NX4 PREMIUM GRIS ORION": 'spins/TUCSON/grisorion',
                "TUCSON NX4 PREMIUM NEGRO FANTASMA": 'spins/TUCSON/negrofantasma',
                "TUCSON NX4 PREMIUM PLATA DIAMANTE": 'spins/TUCSON/platadiamante',
                "TUCSON NX4 PREMIUM ROJO ATARDECER": 'spins/TUCSON/rojoatardecer',

                "TUCSON NX4 ATTRACTION BLANCO POLAR": 'spins/TUCSONATTRACTION/blancopolar',
                "TUCSON NX4 ATTRACTION BRONCE SIENA": 'spins/TUCSONATTRACTION/broncesiena',
                "TUCSON NX4 ATTRACTION GRIS ASTRAL": 'spins/TUCSONATTRACTION/grisastral',
                "TUCSON NX4 ATTRACTION GRIS ORION": 'spins/TUCSONATTRACTION/grisorion',
                "TUCSON NX4 ATTRACTION NEGRO FANTASMA": 'spins/TUCSONATTRACTION/negrofantasma',
                "TUCSON NX4 ATTRACTION PLATA DIAMANTE": 'spins/TUCSONATTRACTION/platadiamante',
                "TUCSON NX4 ATTRACTION ROJO ATARDECER": 'spins/TUCSONATTRACTION/rojoatardecer',

                "TUCSON NX4 LIMITED BLANCO POLAR": 'spins/TUCSONLIMITED/blancopolar',
                "TUCSON NX4 LIMITED BRONCE SIENA": 'spins/TUCSONLIMITED/broncesiena',
                "TUCSON NX4 LIMITED GRIS ASTRAL": 'spins/TUCSONLIMITED/grisastral',
                "TUCSON NX4 LIMITED GRIS ORION": 'spins/TUCSONLIMITED/grisorion',
                "TUCSON NX4 LIMITED NEGRO FANTASMA": 'spins/TUCSONLIMITED/negrofantasma',
                "TUCSON NX4 LIMITED PLATA DIAMANTE": 'spins/TUCSONLIMITED/platadiamante',
                "TUCSON NX4 LIMITED ROJO ATARDECER": 'spins/TUCSONLIMITED/rojoatardecer',

                "KONA LIMITED AZUL SURFY": 'spins/KONALIMITED/azulsurfy',
                "KONA LIMITED BLANCO ATLAS": 'spins/KONALIMITED/blancoatlas',
                "KONA LIMITED GRIS GALACTICO": 'spins/KONALIMITED/grisgalactico',
                "KONA LIMITED NEGRO FANTASMA": 'spins/KONALIMITED/negrofantasma',
                "KONA LIMITED PLATA CIBERNETICO": 'spins/KONALIMITED/platacibernetico',
                "KONA LIMITED ROJO PULSO": 'spins/KONALIMITED/rojopulso',

                "KONA PREMIUM AZUL SURFY": 'spins/KONAPREMIUM/azulsurfy',
                "KONA PREMIUM BLANCO ATLAS": 'spins/KONAPREMIUM/blancoatlas',
                "KONA PREMIUM GRIS GALACTICO": 'spins/KONAPREMIUM/grisgalactico',
                "KONA PREMIUM PLATA CIBERNETICO": 'spins/KONAPREMIUM/platacibernetico',
                "KONA PREMIUM ROJO PULSO": 'spins/KONAPREMIUM/rojopulso',

                "VENUE PREMIUM MT AZUL INTENSO": 'spins/VENUE/AzulIntenso',
                "VENUE PREMIUM MT BLANCO POLAR": 'spins/VENUE/BlancoPolar',
                "VENUE PREMIUM MT GRIS COSMICO": 'spins/VENUE/GrisCosmico',
                "VENUE PREMIUM MT NARANJA VOLCAN": 'spins/VENUE/NaranjaVolcan',
                "VENUE PREMIUM MT PLATA CICLON": 'spins/VENUE/PlataCiclon',
                "VENUE PREMIUM MT ROJO PASION": 'spins/VENUE/RojoPasion',

                "SUPER METRO ACCENT ": 'spins/SUPERMETROACCENT/',

                "GRAND METRO HB ": 'spins/GRANDMETROHB/',

                "GRAND METRO SEDAN ": 'spins/GRANDMETROSEDAN/',

                "HD78 CONGELACION": 'spins/HD/Carroceria_Congelacion/',
                "HD78 ESTACAS": 'spins/HD/Carroceria_Estacas/',
                "HD78 PLANCHON": 'spins/HD/Carroceria_Planchon/',

                "HD65 CONGELACION": 'spins/HD/Carroceria_Congelacion/',
                "HD65 ESTACAS": 'spins/HD/Carroceria_Estacas/',
                "HD65 PLANCHON": 'spins/HD/Carroceria_Planchon/',

                "HD55 CONGELACION": 'spins/HD/Carroceria_Congelacion/',
                "HD55 ESTACAS": 'spins/HD/Carroceria_Estacas/',
                "HD55 PLANCHON": 'spins/HD/Carroceria_Planchon/',

                "STARIA ": 'spins/STARIA/',

                "EX8 CONGELACION": 'spins/EX8/Congelacion/',
                "EX8 ESTACAS": 'spins/EX8/Estacas/',
                "EX8 PLANCHON": 'spins/EX8/Planchon/',

                "EX10 CONGELACION": 'spins/EX10/Congelacion/',
                "EX10 ESTACAS": 'spins/EX10/Estacas/',
                "EX10 PLANCHON": 'spins/EX10/Planchon/',

                "GRAND METRO TAXI ": 'spins/GRANDI10/',

                "STARIA PASAJEROS ": 'spins/STARIA/',
            }
        ]
    }
}